export const initHamburger = () => {
  const header = document.querySelector('[data-header]');
  const trigger = document.querySelector('[data-hamburger-trigger]');
  if (!header || !trigger) {
    return;
  }
  const mediaQuery = window.matchMedia('(min-width: 1161px)');
  function close() {
    window.scrollLock.enableScrolling();
    header.classList.remove('hamburger-open');
  }
  function open() {
    window.scrollLock.disableScrolling();
    header.classList.add('hamburger-open');
  }
  trigger.addEventListener('click', () => {
    if (header.classList.contains('hamburger-open')) {
      close();
    } else {
      open();
    }
  });
  mediaQuery.addEventListener('change', () => {
    if (mediaQuery.matches) {
      close();
    }
  });
};
